var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B3B3B3",
    d: "M25,26h-2v-5H2c-0.553,0-1-0.448-1-1V8c0-0.552,0.447-1,1-1h6v2H3v10h21c0.553,0,1,0.448,1,1V26z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 26,
    fill: "#444444",
    width: 8,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    d: "M28,47h-8c-0.553,0-1-0.448-1-1V26c0-0.552,0.447-1,1-1h8c0.553,0,1,0.448,1,1v20C29,46.552,28.553,47,28,47 z M21,45h6V27h-6V45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#43A6DD",
    d: "M38,32c0-2.209,4-8,4-8s4,5.791,4,8s-1.791,4-4,4S38,34.209,38,32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#43A6DD",
    d: "M42,37c-2.757,0-5-2.243-5-5c0-2.399,3.479-7.559,4.177-8.568L42,22.24l0.823,1.191 C43.521,24.441,47,29.601,47,32C47,34.757,44.757,37,42,37z M42,25.808c-1.439,2.249-3,5.1-3,6.192c0,1.654,1.346,3,3,3s3-1.346,3-3 C45,30.907,43.439,28.057,42,25.808z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFD358",
    d: "M40,15H8c-1.105,0-2-0.895-2-2V4h36v9C42,14.105,41.105,15,40,15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#43A6DD",
    d: "M42,3v2H6V3c0-1.105,0.895-2,2-2h32C41.105,1,42,1.895,42,3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.da88dc344c4d3cc7e5243857c2cd528e.svg";
export { ForwardRef as ReactComponent };